import {Injectable} from '@angular/core';
import {PartnerAddress} from "@app/shared/classes/trading-partner";
import {Address} from "@app/shared/classes/address";
import {OrgAddress} from "@app/shared/classes/org-address";
import {CommonTransformationService} from "@app/shared";
import {SelectItem} from "primeng/api";

@Injectable()
export class AddressService {

  constructor(private transform: CommonTransformationService) {
  }

  convertPartnerAddressToAddress(partnerAddresses: PartnerAddress): Address {
    let address = new Address();
    address.id = partnerAddresses.id;
    address.addrLn1 = partnerAddresses.addrLn1;
    address.addrLn2 = partnerAddresses.addrLn2;
    address.city = partnerAddresses.city;
    address.stateCode = partnerAddresses.stateCode;
    address.postalCode = partnerAddresses.postalCode;
    address.country = partnerAddresses.country;
    return address;
  }

  convertPartnerAddressListToAddressList(partnerAddresses: PartnerAddress[]): Address[] {
    let addressList: Address[] = [];
    partnerAddresses.forEach(partnerAddresses => {
      addressList.push(this.convertPartnerAddressToAddress(partnerAddresses));
    });
    return addressList;
  }

  convertPartnerAddressToDropdown(partnerAddresses: PartnerAddress[], labelProperty: string): SelectItem[] {
    labelProperty = labelProperty ? labelProperty : "addrName";

    let addressList = this.convertPartnerAddressListToAddressList(partnerAddresses);
    return this.transform.convertToDropDown(labelProperty, addressList, null, true);
  }

  convertToPartnerAddress(address: OrgAddress): PartnerAddress {
    let partnerAddress = new PartnerAddress();
    if (!address) {
      return partnerAddress;
    }
    if (address.addrLn1) {
      partnerAddress.addrLn1 = address.addrLn1;
    }
    if (address.addrLn2) {
      partnerAddress.addrLn2 = address.addrLn2;
    }

    if (address.addrName) {
      partnerAddress.addrName = address.addrName;
    }

    if (address.addrType) {
      partnerAddress.addrType = address.addrType;
    }

    if (address.city) {
      partnerAddress.city = address.city;
    }

    if (address.stateCode) {
      partnerAddress.stateCode = address.stateCode;
    }

    if (address.country) {
      partnerAddress.country = address.country;
    }

    if(address.faxPhone) {
      partnerAddress.faxPhone = address.faxPhone;
    }

    if (address.locationCode) {
      partnerAddress.locationCode = address.locationCode;
    }

    if (address.mainPhone) {
      partnerAddress.mainPhone = address.mainPhone;
    }

    if (address.postalCode) {
      partnerAddress.postalCode = address.postalCode;
    }

    return partnerAddress;
  }

}
